import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'Components';
import './Custom.css';

const Custom = ({ onButtonClick, title, subTitle }) => (
  <div>
    <Button onClick={onButtonClick} className="actions__custom">
      <div className="actions__custom__text">
        <div>{title}</div>
        <div>{subTitle}</div>
      </div>
      <Icon icon="add_circle" />
    </Button>
  </div>
);

Custom.propTypes = {
  onButtonClick: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};
export default Custom;



// WEBPACK FOOTER //
// ./src/components/Actions/Custom/Custom.jsx